export enum GenerischeFreigabeVariables {
  vorname = "vorname",
  nachname = "nachname",
  _bokuFlow_workflowResultProtocolJSON = "_bokuFlow_workflowResultProtocolJSON",
  workflowResult = "workflowResult",
  documentToApprove = "documentToApprove",
  originalDocumentFilename = "originalDocumentFilename",
  annotatedDocument = "annotatedDocument",
  comment = "comment",
  attachments = "attachments",
  originalDocument = "originalDocument",
  additionalApprovers = "additionalApprovers",
  annotatedDocumentNode = "annotatedDocumentNode",
  annotatedDocumentFilename = "annotatedDocumentFilename",
  recipients = "recipients"
}

export const GenerischeFreigabeVariablesSearchable = [
  GenerischeFreigabeVariables.originalDocumentFilename,
  GenerischeFreigabeVariables.comment,
]
